import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import authApi from "@/api/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "root",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../pages/auth/LoginPage.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../pages/auth/RegisterPage.vue"),
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () => import("../pages/auth/ForgotPasswordPage.vue"),
  },
  // {
  //   path: "/confirmation",
  //   name: "confirmation",
  //   component: () => import("../pages/auth/ConfirmationPage.vue"),
  // },
  {
    path: "/profile",
    redirect: "/profile/settings",
    component: () => import("../pages/profile/ProfilePage.vue"),
    children: [
      {
        path: "settings",
        name: "profile-settings",
        component: () => import("../pages/profile/settings/SettingsPage.vue"),
      },
      {
        path: "history",
        name: "profile-history",
        component: () => import("../pages/profile/history/HistoryPage.vue"),
      },
      {
        path: "travelers",
        name: "profile-travelers",
        component: () => import("../pages/profile/travelers/TravelersPage.vue"),
      },
      {
        path: "orders",
        name: "profile-orders",
        redirect: "/profile/orders/tours",
        component: () => import("../pages/profile/orders/OrdersPage.vue"),
        children: [
          {
            path: "avia",
            name: "profile-orders-avia",
            component: () =>
              import("../pages/profile/orders/avia/AviaPage.vue"),
          },
          {
            path: "avia/:id",
            name: "profile-orders-avia-detail",
            component: () =>
              import("../pages/profile/orders/avia/OrderDetail.vue"),
          },
          {
            path: "tours",
            name: "profile-orders-tours",
            component: () =>
              import("../pages/profile/orders/tours/ToursPage.vue"),
          },
          {
            path: "tours/:id",
            name: "profile-orders-tours-detail",
            component: () =>
              import("../pages/profile/orders/tours/OrderDetail.vue"),
          },
          {
            path: "lounges",
            name: "profile-orders-lounges",
            component: () =>
              import("../pages/profile/orders/lounges/LoungesPage.vue"),
          },
          {
            path: "lounges/:id",
            name: "profile-orders-lounges-detail",
            component: () => import("../pages/profile/orders/Detail.vue"),
          },
          {
            path: "hotels",
            name: "profile-orders-hotels",
            component: () =>
              import("../pages/profile/orders/hotels/HotelsPage.vue"),
          },
          {
            path: "hotels/:id",
            name: "profile-orders-hotels-detail",
            component: () =>
              import("../pages/profile/orders/hotels/OrderDetail.vue"),
          },
          {
            path: "insurance",
            name: "profile-orders-insurance",
            component: () =>
              import("../pages/profile/orders/insurance/InsurancePage.vue"),
          },
          {
            path: "insurance/:id",
            name: "profile-orders-insurance-detail",
            component: () =>
              import("../pages/profile/orders/Detail.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "*",
    redirect: "/login",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const publicPages = ["login", "register", "forgot-password"];
  const isPublicPage = publicPages.includes(to.name);

  const isAuthenticated = store.state.authStore.user;

  if (isAuthenticated) {
    if (isPublicPage) {
      return next({ name: "profile-settings" });
    }
    return next();
  } else {
    if (isPublicPage) {
      return next();
    }

    try {
      const response = await authApi.checkIn();

      if (response) {
        await store.dispatch("authStore/checkIn", response);

        return next({ name: "profile-settings" });
      } else {
        return next({ name: "login" });
      }
    } catch (error) {
      store.dispatch("glodalStore/showTip", `Auth check failed: ${error}`);
      return next({ name: "login" });
    }
  }
});

export default router;
